module.exports = __webpack_public_path__ + "../resources/img/ic_compass.8c82f2f2.svg";